import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ExternalBranchJobFilterEntity } from '../../domain/entities/ExternalBranchJobFilterEntity'

export class ExternalBranchJobFilterModel extends ExternalBranchJobFilterEntity {
  fromDate?: string
  toDate?: string
  constructor(dataDto: ExternalBranchJobFilterEntity) {
    super()
    mapEntityProperties<ExternalBranchJobFilterModel>(this, dataDto, {
      exclude: ['date'],
      map: {
        fromDate: dataDto.date ? dataDto.date[0] : undefined,
        toDate: dataDto.date ? dataDto.date[1] : undefined
      }
    })
  }
}
